// Marketing and Analytics Configuration
const getEnvVar = (key: string, fallback: string = ''): string => {
  return import.meta.env[key] || fallback;
};

export const MARKETING_CONFIG = {
  // Google Analytics
  googleAnalytics: {
    enabled: getEnvVar('VITE_GA_ENABLED', 'false') === 'true',
    measurementId: getEnvVar('VITE_GA_MEASUREMENT_ID', ''),
  },
  
  // Google Ads / Google Tag Manager
  googleAds: {
    enabled: getEnvVar('VITE_GOOGLE_ADS_ENABLED', 'false') === 'true',
    conversionId: getEnvVar('VITE_GOOGLE_ADS_CONVERSION_ID', ''),
    conversionLabel: getEnvVar('VITE_GOOGLE_ADS_CONVERSION_LABEL', ''),
  },
  
  // Facebook Pixel
  facebookPixel: {
    enabled: getEnvVar('VITE_FB_PIXEL_ENABLED', 'false') === 'true',
    pixelId: getEnvVar('VITE_FB_PIXEL_ID', ''),
  },
  
  // LinkedIn Insight Tag
  linkedIn: {
    enabled: getEnvVar('VITE_LINKEDIN_ENABLED', 'false') === 'true',
    partnerId: getEnvVar('VITE_LINKEDIN_PARTNER_ID', ''),
  },
  
  // Twitter Pixel
  twitter: {
    enabled: getEnvVar('VITE_TWITTER_ENABLED', 'false') === 'true',
    pixelId: getEnvVar('VITE_TWITTER_PIXEL_ID', ''),
  },
};

// Facebook Pixel Helper Functions
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
    _linkedin_partner_id?: string;
    twq?: (...args: any[]) => void;
  }
}

export const trackFacebookEvent = (eventName: string, params?: Record<string, any>) => {
  if (MARKETING_CONFIG.facebookPixel.enabled && window.fbq) {
    window.fbq('track', eventName, params);
  }
};

export const trackGoogleEvent = (eventName: string, params?: Record<string, any>) => {
  if (MARKETING_CONFIG.googleAnalytics.enabled && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

export const trackGoogleAdsConversion = (conversionLabel?: string) => {
  if (MARKETING_CONFIG.googleAds.enabled && window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': conversionLabel || `${MARKETING_CONFIG.googleAds.conversionId}/${MARKETING_CONFIG.googleAds.conversionLabel}`,
    });
  }
};

export const trackPageView = (path: string) => {
  // Google Analytics
  if (MARKETING_CONFIG.googleAnalytics.enabled && window.gtag) {
    window.gtag('config', MARKETING_CONFIG.googleAnalytics.measurementId, {
      page_path: path,
    });
  }
  
  // Facebook Pixel
  if (MARKETING_CONFIG.facebookPixel.enabled && window.fbq) {
    window.fbq('track', 'PageView');
  }
};




